import { Box } from '@mui/material';
import EditBinForm from '../../features/EditBinForm/EditBinForm';

const EditBin = () => {
  return (
    <Box>
      <EditBinForm />
    </Box>
  );
};
export default EditBin;
